import React from 'react';
import { Link } from 'react-router-dom';
import './MainPageBanner.css';

interface Portal {
  id: number;
  name: string;
  banner_image: string;
  banner_link: string;
  is_active: boolean;
  order: number;
}

interface MainPageBannerProps {
  banner: Portal;
}

const MainPageBanner: React.FC<MainPageBannerProps> = ({ banner }) => {
  if (!banner || !banner.is_active) {
    return null;
  }

  const BannerContent = () => (
    <img
      src={banner.banner_image}
      alt={banner.name}
      className="main-page-banner-image"
      style={{
        width: '100%',
        objectFit: 'cover',
        display: 'block',
        borderRadius: '1rem'
      }}
    />
  );

  return (
    <section className="main-page-banner-section">
      <div className="landing-container">
        <div className="landing-section-header">
          <h2>Zniżka dla klientów Lokalnytrener:</h2>
          <p>Odkryj nasze specjalne oferty promocyjne</p>
        </div>

        <div className="main-page-banner-item">
          {banner.banner_link ? (
            <Link
              to={banner.banner_link}
              className="main-page-banner-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              <BannerContent />
            </Link>
          ) : (
            <div className="main-page-banner-item-container">
              <BannerContent />
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default MainPageBanner;